<template>
	<div>
		<div id="main-contents">
			<Explanation></Explanation>
			<ScoreList></ScoreList>
		</div>
	</div>
</template>

<script>
	import Explanation from "../components/danoni/Explanation.vue";
	import ScoreList from "../components/danoni/ScoreList.vue";
	export default {
		components: {
			Explanation: Explanation,
			ScoreList: ScoreList,
		},
		title: "DancingOnigiri"
	}
</script>

<style scoped>
	#main-contents {
		padding: 16px;
		margin-top: 8px;
	}

	
</style>